export default "__VITE_ASSET__CBY6EcRX__"